export const getState = {
  gettingState: "geo/states",
};
